import { useState, useCallback } from "react";
import Cookies from "js-cookie";
import { postApi } from "../../../../utils/api.ts";
import { API_TIMESHEET_EXTENSION_REQUEST } from "../../../../../config/Endpoints.js";
import { showError, showSuccess } from "../../../../utils/toast.ts";

function resolveEmployeeId(explicitId?: number): number | null {
  if (explicitId != null && !Number.isNaN(explicitId)) {
    return explicitId;
  }
  try {
    const userData = JSON.parse(localStorage.getItem("userData") ?? "null");
    const id = userData?.id;
    return typeof id === "number" ? id : null;
  } catch {
    return null;
  }
}

export function useRequestTimesheetExtension() {
  const [isRequesting, setIsRequesting] = useState(false);
  const accessToken = Cookies.get("accessToken");

  const requestExtension = useCallback(
    async (workDate: string, employeeId?: number) => {
      const empId = resolveEmployeeId(employeeId);
      if (empId == null) {
        showError("Unable to identify your employee account. Please sign in again.");
        return false;
      }

      setIsRequesting(true);
      try {
        const url = `${API_TIMESHEET_EXTENSION_REQUEST}?empId=${empId}&workDate=${workDate}`;
        const { data } = await postApi(url, accessToken, {});
        const message =
          typeof data === "string"
            ? data
            : (data as { message?: string })?.message ??
              "Timesheet extension request submitted successfully.";
        showSuccess(message);
        return true;
      } catch (err: unknown) {
        const message =
          err instanceof Error
            ? err.message
            : "Failed to submit timesheet extension request.";
        showError(message);
        return false;
      } finally {
        setIsRequesting(false);
      }
    },
    [accessToken],
  );

  return { requestExtension, isRequesting };
}
